import { handleActions, combineActions } from 'redux-actions';
import { UPDATE_PROFILE, DELETE_PROFILE, ADD_PROFILE } from '../constants';

const initialState = {
  loading: false,
  error: false,
  success: false,
  response: null,
};

const formReducer = handleActions(
  {
    [combineActions(
      UPDATE_PROFILE.PENDING,
      DELETE_PROFILE.PENDING,
      ADD_PROFILE.PENDING,
    )]: state => ({
      ...state,
      loading: true,
    }),
    [combineActions(
      UPDATE_PROFILE.CANCELLED,
      UPDATE_PROFILE.ERROR,
      UPDATE_PROFILE.SUCCESS,
      ADD_PROFILE.CANCELLED,
      ADD_PROFILE.ERROR,
      ADD_PROFILE.SUCCESS,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [combineActions(
      UPDATE_PROFILE.ERROR,
      DELETE_PROFILE.ERROR,
      ADD_PROFILE.ERROR,
    )]: (state, { payload }) => ({
      ...state,
      error: true,
      response: payload,
    }),
    [combineActions(
      UPDATE_PROFILE.SUCCESS,
      DELETE_PROFILE.SUCCESS,
      ADD_PROFILE.SUCCESS,
    )]: (state, { payload }) => ({
      ...state,
      response: payload,
      success: true,
    }),
    [combineActions(
      UPDATE_PROFILE.CLEAR,
      DELETE_PROFILE.CLEAR,
      ADD_PROFILE.CLEAR,
    )]: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default formReducer;
